import { Divider } from "antd";

const MenuSiderLoading = ({ isMenuCollapsed }) => {
  return (
    <div className="text-[#A5ADB5]">
      <div className=" py-2 px-4 truncate">Filter</div>
      <div className="m-1 px-6 py-2 flex flex-row items-center gap-x-[10px]  rounded-lg animate-pulse cursor-pointer">
        <div className="size-6 rounded-full bg-slate-700 " />
        {!isMenuCollapsed && <div className="w-36 h-4 bg-slate-700" />}
      </div>
      <div className="m-1 px-6 py-2 flex flex-row items-center gap-x-[10px]  rounded-lg animate-pulse cursor-pointer">
        <div className="size-6 rounded-full bg-slate-700 " />
        {!isMenuCollapsed && <div className="w-36 h-4 bg-slate-700" />}
      </div>

      <div className="px-4">
        <Divider className="bg-[#A5ADB5] m-0" />
      </div>
      <div className=" py-2 px-4 truncate">Applications</div>
      <div className="m-1 px-6 py-2 flex flex-row items-center gap-x-[10px]  rounded-lg animate-pulse cursor-pointer">
        <div className="size-6 rounded-full bg-slate-700 " />
        {!isMenuCollapsed && <div className="w-36 h-4 bg-slate-700" />}
      </div>
      <div className="m-1 px-6 py-2 flex flex-row items-center gap-x-[10px]  rounded-lg animate-pulse cursor-pointer">
        <div className="size-6 rounded-full bg-slate-700 " />
        {!isMenuCollapsed && <div className="w-36 h-4 bg-slate-700" />}
      </div>
      <div className="m-1 px-6 py-2 flex flex-row items-center gap-x-[10px]  rounded-lg animate-pulse cursor-pointer">
        <div className="size-6 rounded-full bg-slate-700 " />
        {!isMenuCollapsed && <div className="w-36 h-4 bg-slate-700" />}
      </div>
      <div className="m-1 px-6 py-2 flex flex-row items-center gap-x-[10px]  rounded-lg animate-pulse cursor-pointer">
        <div className="size-6 rounded-full bg-slate-700 " />
        {!isMenuCollapsed && <div className="w-36 h-4 bg-slate-700" />}
      </div>
    </div>
  );
};

export default MenuSiderLoading;
